export function defaultFieldNameSelector(artisType) {
    switch (artisType) {
        case "eod":
        case "customer_curve":
            return "value";
        default:
            return "fv";
    }
}
export const getFieldSelector = (artisType, field) => {
    switch (artisType) {
        case "eod":
        case "customer_curve":
            return "value";
        default:
            return field ?? "fv";
    }
};
//# sourceMappingURL=products.js.map